/* ═══════════════════════════════════════════
   File Parser types (Гибкий парсер файлов)
   ═══════════════════════════════════════════ */

/** Named separator types */
export type SeparatorType = 'auto' | 'comma' | 'semicolon' | 'tab' | 'pipe' | 'space' | 'fixed' | 'none'

/** Configuration for file parsing */
export interface ParseConfig {
  separator: SeparatorType
  fixed_positions?: number[]
  start_row: number
  column_index: number
  /** Column for pallet codes when single_file + ka_box_pallet */
  column_index_pallets?: number
  encoding: string
  strict_checksum: boolean
  file_mode?: 'two_files' | 'single_file'
}

/** Preview result from POST /api/file-parser/preview */
export interface FilePreviewResult {
  rows: string[][]
  total_lines: number
  detected_separator: string
  column_count: number
  encoding_detected: string
  is_excel: boolean
}

/** Skipped row info returned from load-file */
export interface SkippedRow {
  row: number
  value: string
  reason: string
}

/** Extended load result with warnings */
export interface LoadFileResult {
  warnings?: string[]
  skipped_rows?: SkippedRow[]
}

/** Human-readable separator labels */
export const SEPARATOR_LABELS: Record<SeparatorType, string> = {
  auto: 'Автоопределение',
  comma: 'Запятая (,)',
  semicolon: 'Точка с запятой (;)',
  tab: 'Табуляция',
  pipe: 'Вертикальная черта (|)',
  space: 'Пробел',
  fixed: 'Фиксированная ширина',
  none: 'Нет разделителя',
}

/** Default parse config */
export const DEFAULT_PARSE_CONFIG: ParseConfig = {
  separator: 'auto',
  start_row: 0,
  column_index: 0,
  encoding: 'auto',
  strict_checksum: true,
}
